import * as PropTypes from "prop-types"
import { color } from "helpers/styled"
import styled from "styled-components"
import Item from "../Item"

const PromoCard = styled(Item)`
  --promo-bg: linear-gradient(71deg, ${color("skyBlue")} -4%, ${color("mediumBlue")} 64%, ${color("purple")} 103%);
`

function Promotion({ title, description }) {
  return <PromoCard title={title} description={description} image="gift" alt="" />
}

Promotion.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
}

export default Promotion
